import ReactDOM from 'react-dom/client';
import App from './App';
import { ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';

import 'bootstrap/dist/css/bootstrap.min.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<>
  {/*<React.StrictMode>*/}
  <ConfigProvider locale={esES}>
    <App />
  </ConfigProvider>
  {/*</React.StrictMode>*/}
  </>
);